<template>
  <div class="wrap" style="background:#FBFBFB;">
     <div class="ccod_join">
        <img style="margin-top:207px;margin-bottom: 30px;" src="../assets/img/banner_logo.png">
        <h2>我们期待你的加入</h2>
    </div>
   
   
    <div class="ccod-section-contact">
        <div class="ccod-section-contact-content">
            <div class="ccod-section-contact-company">
                <div class="company-name"  v-for="(item, index) in contactList" :key="index" @mouseover="choiceCompanyAddress(item, index)">{{item.cityName}}</div>
            </div>
            <div class="content-detail">
                 <ul class="ccod-info">
                    <li v-for="(items, index) in contactList[choiceCompanyIndex].info" :key="index">
                        <p class="zhiClass">{{items.jobName}}</p>
                        <p class="enlName">{{items.EnglishiName}}</p>
                        <p class="zhize">岗位职责:</p>
                        <span class="nemeCon" v-for="(atem,index) in items.duty" :key="index">{{atem}}</span>
                        <p class="yaoqiu">任职资格要求:</p>
                        <span v-for="(btem) in items.requirement" :key="btem">{{btem.trim()}}</span>
                    </li>
                </ul>
            </div>
            <p class="ccod_email">
                如对职位有意向，请投递简历至<a href="mailto:qnzhaopin@channelsoft.com" target="_blank"><span>qnzhaopin@channelsoft.com</span></a>
            </p>
        </div>
    </div>
  </div>

</template>

<script>
export default {
    data(){
      return{
        choiceCompanyIndex:0,
        contactList:[
            {
                cityName:'北京',
                info:[
                 {
                    jobName:'Java软件工程师',
                    EnglishiName:'Java Software Engineer',
                    duty:['1、参与公司Java项目的研发工作；','2、完成软件产品各模块的功能设计、代码实现工作；','3、负责软件模块的单元测试与集成测试；','4、编写、维护软件开发文档。'],
                    requirement:['1、1到3年基于Java的Web项目开发经验，有产品设计和开发经验；','2、Java基础扎实，良好的代码风格，具备良好的编程习惯、文档写作及管理能力；','3、熟练使用基于J2EE的相关开源技术以及框架，例如：（SpringMVC，mybatis，Hibernate）','4、熟练使用Junit(或者其他)进行测试代码的编写；','5、熟悉SOA架构，能够使用Axis2或CXF框架进行Web Service开发；',' 6、熟悉MYSQL，ORACLE等关系数据库及redis、mongoDB等非关系型数据库。']
                  },
                    {
                        jobName:'高级软件工程师',
                        EnglishiName:'Senior Software Engineer',
                        duty:['1、参与数据库设计，优化数据库结构。设计数据库索引、存储过程；','2、负责业务数据库性能调优、安全管理、数据备份，现网问题分析处理 ','3、总结和撰写相应的数据库文档；','4、对开发者的数据库访问代码进行评审和优化。'],
                        requirement:['1、本科及以上学历，计算机或数学相关专业，扎实的计算机专业基本功；','2、3年以上数据库服务开发经验（Java语言），熟悉常见的sql及nosql数据库；','3、具备良好的分析解决问题能力，能独立承担任务，能承受一定压力；','4、有云计算平台相关设计及开发经验者优先。']
                    },{
                        jobName:'技术支持工程师',
                        EnglishiName:'Technical Support Engineer',
                        duty:['1、所负责平台有应急方案，有程序和配置文件备份；','2、平台升级前有升级方案，审批后严格按升级时间进行升级和测试验证，并输出升级结果及过程文档；','3、平台出现一、二级重大故障需积极响应处理并及时上报；','4、按要求熟练使用Mantis工具和运维支撑工具；','5、平台所有操作需按支撑操作流程规范执行；','6、监控平台运行情况和平台坐席使用率。'],
                        requirement:['1、大专及以上学历，计算机相关专业，1-3年工作经验；','2、熟练掌握linux系统，熟练编写shell脚本，能独立分析操作系统日志；','3、熟悉oracle、mysql数据库；','4、具备一定的组织协调和项目协调能力，具备运维经验；','5、有呼叫中心从业经验者优先考虑，有呼叫中心从业经 验者优先考虑。']
                    }
                ]
            }, {
                cityName:'上海',
                info:[
                    {
                        jobName:'高级客户经理',
                        EnglishiName:'Senior Account Manager',
                        duty:['1、负责目标大客户的开发与关系维护工作，与目标大客户建立良好的业务关系，挖掘大客户的需求，带领团队高效灵活的完成销售任务；',' 2、参与市场调查、竞争对手研究、营销策划等，及时反馈有关市场开发和营销进展的情况；',' 3、建立大客户档案，并针对客户提供咨询和相关服务，及时处理大客户投诉等事宜；',' 4、完成公司下达的销售任务及其他工作。'],
                        requirement:['1、本科及以上学历；',' 2、5年以上销售工作经验，2年以上组建和管理销售团队工作经验，营销、管理、金融等专业优先考虑； ','3、具备客户资源，具有良好的客户沟通、人际交往及维系客户关系的能力；',' 4、具备自我约束、激励并勇于承担、完成目标责任的能力，能在一定的压力下胜任工作；',' 5、有广泛的社会关系网络和客户人脉资源（浦发、招行等银行资源或人保等保险资源），具有开发大客户经验者优先。']
                    }
                ]
            }, 
            // {
            //     cityName:'深圳',
            //     info:[
                   
            //     ]
            // }
        ]
      }
    },
    methods:{
        choiceCompanyAddress(item, index) {
            this.choiceCompanyIndex = index;
            // console.log(this.choiceCompanyIndex);
        }
    },
  mounted () {
      $(".company-name").eq(0).addClass('active');
    $(".company-name").hover(function () {
      $(this).addClass('active').siblings().removeClass('active')
    })
  }
}
</script>

<style scoped>
     .ccod_join{
        min-width: 1360px;
        height: 560px;
        background: url('../assets/img/job.png') no-repeat center;
        /* background-size: 100% 100%; */
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
     .ccod_join h2{
       color: #ffffff;
       font-size: 50px;
       font-weight: 500;
     }
     .ccod-section-contact{
         position: relative;
         min-width: 1360px;
         display: flex;
         justify-content: center;
         min-height:500px;
        /* overflow: hidden;*/
         background: #F8F8F8;

     }
     .ccod-section-contact-content{
         width: 1120px;
         height: auto;
         overflow: hidden;
         box-shadow: 0px 0px 2px 0px #ccc;
         padding-bottom:  60px;
         margin-bottom: 60px;
         display: flex;
         flex-direction: column;
         justify-content: center;
       margin-top: -94px;
       border-radius: 10px;
         /*transform: scale(1.05);*/
     }
     .ccod-section-contact-company{
         display: flex;
         align-items: center;
         justify-content: center;
         color: #000;
       background: #fff;
         border-bottom:1px solid #ccc; 
        
     }
     .company-name{
        width: 333px;
        height: 94px;
        text-align: center;
        line-height: 94px;
        color: #333333;
        font-size: 18px;
       cursor: pointer;
       position: relative;
       padding-bottom: 0!important;
       border-bottom: 0!important;
     }
     .company-name:after{
       content: '';
       position: absolute;
       width: 1px;
       height: 34px;
       background: #D5D5D5;
       right: 0;
       top: 30px;
     }
     .company-name.active{
       background: #444D70;
       color: #fff;
     }
     .company-name:nth-child(3):after{
       width: 0;
     }
     .company-name:hover{
         background: #444D70;
         color: #fff;
         transition: all 0.3s;
     }
     .company-name:hover:after{
       width: 0;
     }
      /*.ChoiceFlag {
        color: #4565B6;
        background: #444D70;
        color: #fff;
    }*/
    /*.content-detail{
        min-width: 786px;
        height: auto;
        display: flex;
        justify-content: center;
        overflow: scroll;
    }*/
    .ccod-info{
        height: auto;
        overflow: hidden;
        width: 1120px;
    }
    .ccod-info li{
        text-align: justify;
        border-bottom: 1px solid #ccc;
        width: 40%;
        padding-top: 80px;
        float: left;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-height: 600px;
    }
     .ccod-info li:last-child{
        border-bottom: 0;
    }
     .ccod-info li:nth-last-of-type(2){
         border: 0;
     }
     .ccod-info li:nth-child(odd) { 
         margin-left:5%;
         padding-right:10%;
      }
      /* .ccod-info li:nth-child(even) { 
         margin-right:92px;
      } */
    .ccod-info li span{
        /*width: 100%;*/
        text-align: justify;
        color: #333;
        font-size: 16px;
      line-height: 24px;
    }
    .ccod_email{
        font-size: 16px;
        color: #333;
        text-align: center;
        margin-top: 60px;
        display: block;
        line-height: 22px;
    }
    .ccod_email span{
        color: #4565B6;
    }
     .ccod-info li .zhiClass{
         color: #4565B6;
         font-size:20px;
     }
      .ccod-info li .enlName{
         color: #333333;
         font-size:16px;
     }
     .ccod-info li .zhize{
         color: #333333;
         font-size:16px;
         margin-top:30px;
         margin-bottom: 20px;
     }
     .ccod-info li .yaoqiu{
         color: #333333;
         font-size:16px;
         margin:20px 0;
     }
</style>





// WEBPACK FOOTER //
// src/components/OnJob.vue